// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.change-presets-title {
    margin: 0 0 0.75rem 0;
    font-size: 1.5rem;
    color: var(--light-grey-color);
    font-weight: normal;
}

.preset-stepper-row {
    display: flex;
    flex-direction: column;
    margin: 1rem 0;
}

.preset-stepper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
}

.preset-stepper .stepper-btn {
    font-size: 2rem;
    width: 3rem;
    height: 3rem;
    border: none;
    background-color: transparent;
    border: 2px solid var(--main-foreground-color);
    color: var(--main-foreground-color);
    border-radius: 50%;
    cursor: pointer;
    line-height: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.preset-stepper .stepper-btn:disabled {
    opacity: 0.3;
    cursor: default;
}

.preset-stepper .stepper-value {
    font-size: 2.2rem;
    font-weight: bold;
    text-align: center;
    flex: 1 1;
    color: var(--secondary-color);
}

.preset-stepper .stepper-unit {
    font-size: 1rem;
    font-weight: normal;
    color: var(--light-grey-color);
}

.save-presets {
    font-size: 1.8rem;
    margin: 0.5rem;
    margin-top: 1rem;
    color: var(--main-foreground-color);
    background-color: transparent;
    border: 2px solid var(--main-foreground-color);
    border-radius: 999px;
    padding: 0.2rem 1.5rem;
    cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/components/ChangePresetsModal.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,6BAA6B;IAC7B,8CAA8C;IAC9C,mCAAmC;IACnC,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,SAAO;IACP,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,mCAAmC;IACnC,6BAA6B;IAC7B,8CAA8C;IAC9C,oBAAoB;IACpB,sBAAsB;IACtB,eAAe;AACnB","sourcesContent":[".change-presets-title {\n    margin: 0 0 0.75rem 0;\n    font-size: 1.5rem;\n    color: var(--light-grey-color);\n    font-weight: normal;\n}\n\n.preset-stepper-row {\n    display: flex;\n    flex-direction: column;\n    margin: 1rem 0;\n}\n\n.preset-stepper {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n}\n\n.preset-stepper .stepper-btn {\n    font-size: 2rem;\n    width: 3rem;\n    height: 3rem;\n    border: none;\n    background-color: transparent;\n    border: 2px solid var(--main-foreground-color);\n    color: var(--main-foreground-color);\n    border-radius: 50%;\n    cursor: pointer;\n    line-height: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n}\n\n.preset-stepper .stepper-btn:disabled {\n    opacity: 0.3;\n    cursor: default;\n}\n\n.preset-stepper .stepper-value {\n    font-size: 2.2rem;\n    font-weight: bold;\n    text-align: center;\n    flex: 1;\n    color: var(--secondary-color);\n}\n\n.preset-stepper .stepper-unit {\n    font-size: 1rem;\n    font-weight: normal;\n    color: var(--light-grey-color);\n}\n\n.save-presets {\n    font-size: 1.8rem;\n    margin: 0.5rem;\n    margin-top: 1rem;\n    color: var(--main-foreground-color);\n    background-color: transparent;\n    border: 2px solid var(--main-foreground-color);\n    border-radius: 999px;\n    padding: 0.2rem 1.5rem;\n    cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
